export const LanguageTypes = {
	SHOW_LANGUAGE: "SHOW_LANGUAGE",
	FETCH_LANGUAGE: "FETCH_LANGUAGE",
	SET_LANGUAGE: "SET_LANGUAGE",
}